import { CSSProperties } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import cs from 'classnames';

import { SpinnerSizes } from 'constants/enums';

import styles from './LoadingSpinner.module.scss';

interface LoadingSpinnerProps {
  isFullHeight?: boolean;
  size?: SpinnerSizes;
  className?: string;
  isPageSpinner?: boolean;
  style?: CSSProperties;
}
const LoadingSpinner = ({
  isFullHeight = true,
  size = SpinnerSizes.Large,
  className = '',
  isPageSpinner = false,
  style = {}
}: LoadingSpinnerProps) => (
  <div
    className={cs(
      {
        [styles.spinnerContainer]: isFullHeight,
        [styles.pageSpinner]: isPageSpinner
      },
      className
    )}
    style={style}
  >
    <Spin indicator={<LoadingOutlined style={{ fontSize: size }} spin />} />
  </div>
);
export default LoadingSpinner;
